import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { IconName, MemreIcon, MemreText } from './index';
import { Color } from 'core';

export default function MemreAccordion({ id, handleOpen, children, title, isOpen }) {
  return (
    <Accordion
      key={id + isOpen}
      expanded={isOpen}
      onChange={handleOpen}
      sx={{ width: '100%', border: 'none', boxShadow: 'none' }}
    >
      <AccordionSummary
        expandIcon={<MemreIcon iconName={IconName.chevronDown} />}
        sx={{
          borderBottom: isOpen ? `1px solid ${Color.lightGray}` : 'none',
        }}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <MemreText>{title}</MemreText>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
